module.exports = __webpack_public_path__ + "media/steps/loader_icon_1-8ce0ec9b.png";